//@flow
import React from 'react';
import css from './submenu-mobile.css';
import {
  Link
} from 'react-router-dom'
import {
  Actions
} from './actions'

class SubMenuMobile extends React.Component < * > {
  handleClick(e: SyntheticInputEvent < * > ) {
    Actions.setShowMenu(false)
  }

  fixBody(to: boolean) {
    let body = document.getElementsByTagName('BODY');
    if (to) {
      body[0].classList.add("fixBody");
      // body.scrollTop
    } else {
      body[0].classList.remove("fixBody");
    }
  }

  render() {

    this.fixBody(this.props.store.get('showMenu'));

    let items = [];
    Object.entries(this.props.items).forEach(([k, v]) => {
      if (!v) return;
      if (typeof v === 'string') {
        items.push(<Link key={k} onClick={(e)=>this.handleClick(e)} to={v} className={css.link}>{k}</Link>);
      } else if (typeof v === 'function') {
        items.push(<Link key={k} onClick={v} to="#" className={css.link}>{k}</Link>);
      }
    })

    let position = this.props.store.get('showMenu') ? css.show : css.hide;
    let fade = this.props.store.get('showMenu') ? css.in : css.out;
    return <div>
      <div className={[css.shadow,fade].join(" ")} onClick={(e)=>this.handleClick(e)}></div>
    <div className={[css.container,position].join(" ")}>
      {/* <Link className={css.logo} onClick={(e)=>this.handleClick(e)} to="/" >
        <img  src='/images/master-logo/white-text.png' alt='Reminisce logo'/>
      </Link> */}
{items}
    </div>
  </div>;
  }
}
export default SubMenuMobile;